import {computed, type ComputedRef} from 'vue';
import {usePartnerBranding} from '@/ts/composables/stateful/use-partner-branding';
import {VoucherCodeQuery} from '@/ts/types/component/sign-up-type';

/** Determines whether the current user should see Allianz-specific branding based on voucher code, organization, or query param */
export function useAllianzBranding(): {isAllianzUser: ComputedRef<boolean>} {
  const {partner} = usePartnerBranding();

  const isAllianzUser = computed(() => partner.value === VoucherCodeQuery.ALLIANZ);

  return {
    isAllianzUser,
  };
}
